var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invoice-create-page main-content" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-4 col-md-6 col-sm-12" }, [
          _vm.userType == "supplier"
            ? _c("h3", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$tc("customers.view_customer"))),
              ])
            : _vm.userType == "funder"
            ? _c("h3", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$tc("clients.client", 2))),
              ])
            : _vm.userType == "anchor"
            ? _c("h3", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$tc("customers.view_customer"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("ol", { staticClass: "breadcrumb" }, [
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _vm.userType == "supplier"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          slot: "item-title",
                          to: "/supplier/dashboard",
                        },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("general.home")))]
                    )
                  : _vm.userType == "funder"
                  ? _c(
                      "router-link",
                      {
                        attrs: { slot: "item-title", to: "/funder/dashboard" },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("general.home")))]
                    )
                  : _vm.userType == "anchor"
                  ? _c(
                      "router-link",
                      {
                        attrs: { slot: "item-title", to: "/anchor/dashboard" },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("general.home")))]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _vm.userType == "supplier"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          slot: "item-title",
                          to: "/supplier/customers",
                        },
                        slot: "item-title",
                      },
                      [_vm._v("  " + _vm._s(_vm.$tc("customers.customer", 2)))]
                    )
                  : _vm.userType == "funder"
                  ? _c(
                      "router-link",
                      {
                        attrs: { slot: "item-title", to: "/funder/clients" },
                        slot: "item-title",
                      },
                      [_vm._v("  " + _vm._s(_vm.$tc("clients.client", 2)))]
                    )
                  : _vm.userType == "anchor"
                  ? _c(
                      "router-link",
                      {
                        attrs: { slot: "item-title", to: "/anchor/customers" },
                        slot: "item-title",
                      },
                      [_vm._v("  " + _vm._s(_vm.$tc("customers.customer", 2)))]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("li", { staticClass: "breadcrumb-item" }, [
              _c(
                "a",
                {
                  attrs: { slot: "item-title", href: "#/" },
                  on: { click: _vm.viewCustomerPage },
                  slot: "item-title",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.userType == "funder"
                          ? _vm.$tc("clients.view_client")
                          : _vm.$tc("customers.view_customer")
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-8 col-md-6 col-sm-12 align-self-center" },
          [
            _vm.viewCustomer && _vm.viewCustomer.name != null
              ? _c("h3", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.viewCustomer.name)),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row settings-container" }, [
      _c("div", { staticClass: "col-lg-4 settings-sidebar-container" }, [
        _c(
          "ol",
          { staticClass: "settings-sidebar" },
          _vm._l(_vm.finalMenuItems, function (menuItem, index) {
            return _c(
              "li",
              { key: index, staticClass: "sub-menu settings-menu-item" },
              [
                _c(
                  "a",
                  {
                    staticClass: "link-color py-2 position: relative;",
                    attrs: { href: "#" },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "setting-icon",
                      attrs: { icon: [menuItem.iconType, menuItem.icon] },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-3" }, [
                      _vm._v(_vm._s(_vm.$t(menuItem.title))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "right-arrow-submenu" },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "setting-icon",
                          attrs: { icon: "caret-down" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(menuItem.children, function (childItem, childIndex) {
                    return _c(
                      "li",
                      { key: childIndex, staticClass: "settings-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            class: [
                              "link-color",
                              {
                                "active-setting": _vm.hasActiveUrl(
                                  childItem.link
                                ),
                              },
                            ],
                            attrs: { to: childItem.link },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "setting-icon",
                              attrs: {
                                icon: [childItem.iconType, childItem.icon],
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-3" }, [
                              _vm._v(_vm._s(_vm.$t(childItem.title))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.funderProcessingMenu && _vm.userType == "funder"
          ? _c(
              "ol",
              { staticClass: "settings-sidebar" },
              _vm._l(
                _vm.profileMenuItems,
                function (profileMenuItem, profileMenuIndex) {
                  return _c(
                    "li",
                    {
                      key: profileMenuIndex,
                      staticClass: "settings-menu-item",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "link-color py-2 position: relative;",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.profileMenuToggle(profileMenuIndex)
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "setting-icon",
                            attrs: {
                              icon: [
                                profileMenuItem.iconType,
                                profileMenuItem.icon,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }, [
                            _vm._v(_vm._s(_vm.$t(profileMenuItem.title))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right-arrow-submenu" },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "setting-icon",
                                attrs: { icon: "caret-down" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticStyle: { display: "none" },
                          attrs: { id: "profile-submenu-" + profileMenuIndex },
                        },
                        [
                          _vm._l(
                            profileMenuItem.children,
                            function (childItem, childIndex) {
                              return _c(
                                "li",
                                {
                                  key: childIndex,
                                  staticClass: "settings-menu-item",
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      class: [
                                        "link-color",
                                        {
                                          "active-setting": _vm.hasActiveUrl(
                                            childItem.link
                                          ),
                                        },
                                      ],
                                      attrs: { to: childItem.link },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "setting-icon",
                                        attrs: {
                                          icon: [
                                            childItem.iconType,
                                            childItem.icon,
                                          ],
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "ml-3" }, [
                                        _vm._v(_vm._s(_vm.$t(childItem.title))),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c("li", { staticClass: "settings-menu-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "link-color",
                                attrs: {
                                  href: "/users/BBFS/pdf/" + _vm.user,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "setting-icon",
                                  attrs: { icon: "eye" },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "menu-title ml-3" }, [
                                  _vm._v(_vm._s(_vm.$t("general.view_bbfs"))),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ],
                        2
                      ),
                    ]
                  )
                }
              ),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.funderProcessingMenu && _vm.userType == "funder"
          ? _c(
              "ol",
              { staticClass: "settings-sidebar" },
              _vm._l(
                _vm.processMenuItems,
                function (processMenuItem, processMenuIndex) {
                  return _c(
                    "li",
                    {
                      key: processMenuIndex,
                      staticClass: "settings-menu-item",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "link-color py-2 position: relative;",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.processMenuToggle(processMenuIndex)
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "setting-icon",
                            attrs: {
                              icon: [
                                processMenuItem.iconType,
                                processMenuItem.icon,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }, [
                            _vm._v(_vm._s(_vm.$t(processMenuItem.title))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right-arrow-submenu" },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "setting-icon",
                                attrs: { icon: "caret-down" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticStyle: { display: "none" },
                          attrs: { id: "process-submenu-" + processMenuIndex },
                        },
                        _vm._l(
                          processMenuItem.children,
                          function (procesChildItem, processChildIndex) {
                            return _c(
                              "li",
                              {
                                key: processChildIndex,
                                staticClass: "settings-menu-item",
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    class: [
                                      "link-color",
                                      {
                                        "active-setting": _vm.hasActiveUrl(
                                          procesChildItem.link
                                        ),
                                      },
                                    ],
                                    attrs: { to: procesChildItem.link },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "setting-icon",
                                      attrs: {
                                        icon: [
                                          procesChildItem.iconType,
                                          procesChildItem.icon,
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-3" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t(procesChildItem.title))
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                    ]
                  )
                }
              ),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-8" },
        [
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("router-view")],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }